import NotificationsPanel from './NotificationsPanel';
import './NotificationsPanel.scss';

export default NotificationsPanel;
